import { Stack, Title, Text } from '@repletoryreach/sdk-ui';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { ResetForm } from './components/ResetForm';
import { useT } from '../../../i18n/I18nProvider';

export default function ResetPasswordPage() {
  const t = useT();
  const { token } = useParams();
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';

  return (
    <Stack gap="lg">
      <Stack gap="xs">
        <Title order={1}>{t('auth.reset.title')}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)">
          {t('auth.reset.description')}
        </Text>
        {/* The 1-hour expiry was only ever stated on the confirmation the user
            saw an hour ago: not on the page they open when it has lapsed. */}
        <Text role="caption" c="var(--rr-color-text-muted)">
          {t('auth.reset.expiryNote')}
        </Text>
      </Stack>
      <ResetForm token={token ?? ''} email={email} />
      <Text role="caption" c="var(--rr-color-text-muted)">
        <Link to="/auth/login">{t('auth.common.backToSignIn')}</Link>
      </Text>
    </Stack>
  );
}
